// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__32mWb","row":"Page_row__3LzSf","column":"Page_column__FN9wJ"};